import React, {useEffect, useRef} from "react";
import {Link} from "react-router-dom";
import PostTag from "./PostTag";

function hashColor(str, seed) {
    let hash = seed
    for (let i = 0; i < str.length; i++) {
        hash = (hash * 31 + str.charCodeAt(i)) >>> 0
    }
    const r = hash % 256
    const g = (hash >> 8) % 256
    const b = (hash >> 16) % 256
    return `rgb(${r}, ${g}, ${b})`
}

function PostCard(props) {

    const imageRef = useRef(null)

    useEffect(() => {
        if (imageRef.current) {
            imageRef.current.style.background = `linear-gradient(to bottom right, ${hashColor(props.url, 17)}, ${hashColor(props.url, 43)})`
        }
    }, [props.url])

    const filterTags = (tag) => {
        props.addTag(tag)
    }

    return (
        <div className="postcard">
            <Link to={props.url} state={{modal: true}}><div ref={imageRef} className="postcardimage">{props.image}</div></Link>
            <Link to={props.url} state={{modal: true}}><h4 className="postcardtitle">{props.title}</h4></Link>
            <div>
            {props.tags?.map((item, key) => <PostTag key={key} className="posttag" tag={item} onClick={() => filterTags(item)}/>)}

            </div>
        </div>
    )
}

export default PostCard
